<script setup lang="ts">
import { computed } from 'vue'
import {
  Archive,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  BadgePercent,
  Banknote,
  Bell,
  BookText,
  Boxes,
  Building2,
  CalendarCheck,
  CalendarClockIcon,
  CalendarDays,
  CalendarRange,
  CalendarX,
  ChartNoAxesCombined,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CirclePlus,
  CircleStop,
  CircleUserRound,
  Clock,
  Contact,
  Copy,
  CreditCard,
  Download,
  EllipsisVertical,
  Eye,
  EyeOff,
  FileLock,
  Flag,
  FolderTree,
  Globe,
  GripVertical,
  Group,
  Handshake,
  IdCard,
  Info,
  KeyRound,
  LayoutDashboard,
  LayoutList,
  Lightbulb,
  Link2,
  Lock,
  LogIn,
  Mail,
  MailPlus,
  Map,
  MapPin,
  MapPinned,
  MapPinOff,
  Megaphone,
  Menu,
  MessageCircleHeart,
  Network,
  Paperclip,
  Pen,
  Percent,
  Pin,
  Plug,
  Printer,
  Radio,
  Receipt,
  RefreshCw,
  Repeat,
  Rows3,
  ScanQrCode,
  Scale,
  ScrollText,
  Send,
  SendHorizontal,
  Settings,
  ShieldCheck,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  SquareArrowOutUpRight,
  SquareCheck,
  Tags,
  Ticket,
  TicketCheck,
  ToggleRight,
  Trash2,
  Upload,
  UserPen,
  UserPlus,
  Users,
  UsersRound,
  UserX,
  Webhook,
  Workflow,
  X,
} from "@lucide/vue";
import { twMerge } from "tailwind-merge";

export interface IconProps {
  name:
    | 'Archive'
    | 'ArrowLeft'
    | 'ArrowLeftRight'
    | 'ArrowRight'
    | 'BadgePercent'
    | 'Banknote'
    | 'Bell'
    | 'BookText'
    | 'Boxes'
    | 'Building2'
    | 'CalendarCheck'
    | 'CalendarClockIcon'
    | 'CalendarDays'
    | 'CalendarRange'
    | 'CalendarX'
    | 'ChartNoAxesCombined'
    | 'ChevronDown'
    | 'ChevronLeft'
    | 'ChevronRight'
    | 'CircleAlert'
    | 'CircleCheck'
    | 'CircleDashed'
    | 'CirclePlus'
    | 'CircleStop'
    | 'CircleUserRound'
    | 'Clock'
    | 'Contact'
    | 'Copy'
    | 'CreditCard'
    | 'Download'
    | 'EllipsisVertical'
    | 'Eye'
    | 'EyeOff'
    | 'FileLock'
    | 'Flag'
    | 'FolderTree'
    | 'Globe'
    | 'GripVertical'
    | 'Group'
    | 'Handshake'
    | 'IdCard'
    | 'Info'
    | 'KeyRound'
    | 'LayoutDashboard'
    | 'LayoutList'
    | 'Lightbulb'
    | 'Link2'
    | 'Lock'
    | 'LogIn'
    | 'Mail'
    | 'MailPlus'
    | 'Map'
    | 'MapPin'
    | 'MapPinned'
    | 'MapPinOff'
    | 'Megaphone'
    | 'Menu'
    | 'MessageCircleHeart'
    | 'Network'
    | 'Paperclip'
    | 'Pen'
    | 'Percent'
    | 'Pin'
    | 'Plug'
    | 'Printer'
    | 'Radio'
    | 'Receipt'
    | 'RefreshCw'
    | 'Repeat'
    | 'Rows3'
    | 'ScanQrCode'
    | 'Scale'
    | 'ScrollText'
    | 'Send'
    | 'SendHorizontal'
    | 'Settings'
    | 'ShieldCheck'
    | 'ShoppingCart'
    | 'SlidersHorizontal'
    | 'Smartphone'
    | 'Sparkles'
    | 'SquareArrowOutUpRight'
    | 'SquareCheck'
    | 'Tags'
    | 'Ticket'
    | 'TicketCheck'
    | 'ToggleRight'
    | 'Trash2'
    | 'Upload'
    | 'UserPen'
    | 'UserPlus'
    | 'Users'
    | 'UsersRound'
    | 'UserX'
    | 'Webhook'
    | 'Workflow'
    | 'X'
}

const props = defineProps<IconProps>()

const iconComponent = computed(() => {
  const icons = {
    Archive,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    BadgePercent,
    Banknote,
    Bell,
    BookText,
    Boxes,
    Building2,
    CalendarCheck,
    CalendarClockIcon,
    CalendarDays,
    CalendarRange,
    CalendarX,
    ChartNoAxesCombined,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    CircleAlert,
    CircleCheck,
    CircleDashed,
    CirclePlus,
    CircleStop,
    CircleUserRound,
    Clock,
    Contact,
    Copy,
    CreditCard,
    Download,
    EllipsisVertical,
    Eye,
    EyeOff,
    FileLock,
    Flag,
    FolderTree,
    Globe,
    GripVertical,
    Group,
    Handshake,
    IdCard,
    Info,
    KeyRound,
    LayoutDashboard,
    LayoutList,
    Lightbulb,
    Link2,
    Lock,
    LogIn,
    Mail,
    MailPlus,
    Map,
    MapPin,
    MapPinned,
    MapPinOff,
    Megaphone,
    Menu,
    MessageCircleHeart,
    Network,
    Paperclip,
    Pen,
    Percent,
    Pin,
    Plug,
    Printer,
    Radio,
    Receipt,
    RefreshCw,
    Repeat,
    Rows3,
    ScanQrCode,
    Scale,
    ScrollText,
    Send,
    SendHorizontal,
    Settings,
    ShieldCheck,
    ShoppingCart,
    SlidersHorizontal,
    Smartphone,
    Sparkles,
    SquareArrowOutUpRight,
    SquareCheck,
    Tags,
    Ticket,
    TicketCheck,
    ToggleRight,
    Trash2,
    Upload,
    UserPen,
    UserPlus,
    Users,
    UsersRound,
    UserX,
    Webhook,
    Workflow,
    X,
  }
  return icons[props.name]
})
</script>

<template>
  <component
    :is="iconComponent"
    :class="twMerge('tw:w-4 tw:h-4 tw:stroke-current', $attrs.class)"
  />
</template>
